import {Component, Material, Mesh, MeshComponent, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {FlatOffsetMaterial} from '../types/Flatmaterial.js';
import {Mathf} from '../utils/Mathf.js';

export class ScrollingUv extends Component {
    static TypeName = 'scrolling-uv';

    @property.vector2(0, 0)
    uvAnimationRate = [0, 0];
    @property.vector2(0, 0)
    uvOffset = [0, 0];
    @property.vector2(1, 1)
    uvScale = [1, 1];

    private _material: FlatOffsetMaterial;
    private _currentOffset = [0, 0];

    start() {
        const meshComp = this.object.getComponent(MeshComponent);
        this._material = meshComp.material.clone() as FlatOffsetMaterial;
        meshComp.material = this._material;
        this._currentOffset = this.uvOffset;
        this._material.textureOffset = this._currentOffset;
    }

    update(dt: number) {
        if (this.uvAnimationRate[0] !== 0) {
            this._currentOffset[0] = Mathf.fract(
                this._currentOffset[0] + this.uvAnimationRate[0] * dt
            );
        }
        if (this.uvAnimationRate[1] !== 0) {
            this._currentOffset[1] = Mathf.fract(
                this._currentOffset[1] + this.uvAnimationRate[1] * dt
            );
        }
        this._material.textureOffset = this._currentOffset;
    }
}
